import { UserDetail } from '@atom/types/user';

import SectionHeading from '../shared/SectionHeading';

import UserRow from './UserRow';

import classes from './workOrder.module.css';

export type WorkTeamTabProps = { users: UserDetail[] };

const WorkTeamTab = ({ users }: WorkTeamTabProps) => {
  const title = `${users.length} team member${users.length === 1 ? '' : 's'}`;

  return (
    <div>
      <SectionHeading title={title} />
      <div className={classes.userList}>
        {users.map(user => (
          <UserRow key={user.id} user={user} />
        ))}
      </div>
    </div>
  );
};

export default WorkTeamTab;
